export const intialState = {
  auth:false,
  token:""
};
